<template>
    <div id="top">
        <el-container style="">
            <div style="width: 100%;position: relative;height: 68vh;">
                <el-carousel :interval="5000" height="100vh" arrow="always">
                    <el-carousel-item>
                        <img style="width: 100%" src="../static/img/b1.jpg">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img style="width: 100%" src="../static/img/b2.jpg">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img style="width: 100%" src="../static/img/b3.jpg">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img style="width: 100%" src="../static/img/b4.jpg">
                    </el-carousel-item>
                </el-carousel>
            </div>
            <el-header style="position: absolute;z-index: 2;width: 100%;padding: 0 0px;border: none;">
                <el-menu style="background-color: "  mode="horizontal">
                    <el-menu-item class="float_right" index="1">
                        <i class="el-icon-phone-outline"></i>
                        0531-88881231</el-menu-item>
                    <el-menu-item @click="login" class="float_right" index="2">登陆</el-menu-item>
                    <el-menu-item class="float_right men-dc" index="3">
                                关于我们
                        <ul style="margin-left: -20%;display: none" class="ul-dc">
                            <li  class="dd-c">企业介绍</li>
                            <li @click="goAbout" class="dd-c">关于我们</li>
                            <li class="dd-c">企业文化</li>
                            <li class="dd-c">团队风采</li>
                        </ul>
                    </el-menu-item>
                    <el-menu-item class="float_right" index="4">产品与服务</el-menu-item>
                    <el-menu-item @click="navigate" class="float_right" index="5">核心优势</el-menu-item>
                    <el-menu-item class="float_right" style="float: right;" index="6">首页</el-menu-item>
                    <el-menu-item  style="margin-left: 20%;font-size: 22px;color: white" index="7">
                        <img style="width: 100%;height: 65px;" src="../static/img/index/LOGO.png"/>
                    </el-menu-item>
                </el-menu>
            </el-header>
            <el-main style="margin-top: 13%;background-color: white;width: 100%;padding: 0">
                <div style="height: 130vh;width: 100%;background-color: aliceblue;border: 1px solid white">
                    <center>
                        <h2>企业介绍
                        </h2>
                        <div style="width: 80%;height: 180vh">
                            <p style="font-size: 18px">
                                济南哲旭信息技术有限公司始建于2016年，坐落于山东省省会--美丽的泉城济南。是一家专注于工业物联网、工业大数据以及工业云平台、HMI人机界面、数据采集模块等定制产品于一体，专业为客户解决数据采集、传输、控制、显示及处理问题，提供一站式行业解决方案的综合型高新技术企业。
                            </p>
                            <p style="font-size: 18px">
                                以诚信为根本，以技术为核心。作为一家全身心致力于技术研发的高新技术企业，一直以来始终坚持科学发展观、坚持以人为本价值观，将技术研发和人才培养作为公司的发展目标，不断拓展人才培养渠道、完善相应定期不定期等培训体系；不断增加人才培养规模，“传帮带”组织技术观摩学习；不断加大科研技术投入，并专门成立由高学历经验丰富、创新能力强组成的技术研发部门和研发团队。截止目前，公司已然拥有一支员工50余人规模，其中高级工程师2名、专业技术人员5人，平均年龄在27岁左右的核心技术队伍。
                            </p>
                            <p style="font-size: 18px">
                                以质量求生存。依托现有全面丰富的软硬件开发技术科研实力，紧紧围绕客户需求，为客户专业系统化私人订制，只为满足客户对高品质产品及技术服务的要求，从而车联网、新零售、智慧农业、智慧社区、智慧停车解决、智能楼宇、智能工控、智能抄表、智慧光伏等领域能够提供全方位、完整的解决方案。
                            </p>
                            <p style="font-size: 18px">
                                公司倡导“诚信、责任、合作、共赢”的企业精神，以人为本，注重团队的知识化、职业化和年轻化，强调专业水平与综合素质的有效统一。公司以多年的项目实践经验及科学的管理经验成功的打造出一支高素质的经营管理队伍、一支高水平的研发设计队伍、一支高效率的实施维护队伍，为公司广阔的发展打下坚实的基础。
                            </p>
                            <p style="font-size: 18px">
                                坚持“务实中求创新，高效中求发展”的经营理念，以高度的使命感与责任感竭力为用户提供最全面的、最优化的方案和最适合的产品与服务，从而在信息技术领域实现可持续发展，为中国信息技术产业进步作出贡献。
                            </p>
                            <el-row :gutter="1">
                                <el-col :span="8">
                                    <img style="width: 40%;height: 40vh;transform:rotate(270deg)" src="../static/img/index/team1.jpg"/>
                                </el-col>
                                <el-col :span="8">
                                    <img style="width: 40%;height: 40vh;transform:rotate(270deg)" src="../static/img/index/team2.jpg"/>
                                </el-col>
                                <el-col :span="8">
                                    <img style="width: 70%;height: 24vh;margin-top: 15%" src="../static/img/index/team3.jpg"/>
                                </el-col>
                            </el-row>
                        </div>

                    </center>
                </div>
            </el-main>
            <el-footer id="footer" style="background-color: #2b2b2b;width: 100%;height: 40vh">
                <div style="width: 80%;margin: 2% auto">
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <p style="color: white;font-size: 20px">关于我们</p>
                            <p style="color: darkgray;font-weight: normal">企业介绍</p>
                            <p style="color: darkgray;font-weight: normal">咨询中心</p>
                            <p style="color: darkgray;font-weight: normal">联系我们</p>
                        </el-col>
                        <el-col :span="6">
                            <p style="color: white;font-size: 20px">产品与服务</p>
                            <div style="margin-top: 2%">
                                <span style="color: darkgray;font-weight: normal">管控平台</span>
                                <span style="color: darkgray;font-weight: normal;margin-left: 5%">技术支持</span>
                            </div>
                            <div style="margin-top: 2%">
                                <span style="color: darkgray;font-weight: normal">定制功能</span>
                                <span style="color: darkgray;font-weight: normal;margin-left: 5%">售后服务</span>
                            </div>
                            <p style="color: darkgray;font-weight: normal;margin-top: 2%">app研发</p>
                        </el-col>
                        <el-col :span="6">
                            <p style="color: white">联系我们</p>
                            <p style="color: darkgray;font-weight: normal">联系电话</p>
                            <p style="color: darkgray;font-weight: normal">QQ咨询</p>
                        </el-col>
                        <el-col :span="6">
                            <img style="width: 150px;height: 150px" src="../static/img/index/erweima.jpg"/>
                            <p style="color: white;margin-left: 15%">微信公众号</p>
                        </el-col>
                    </el-row>
                </div>
            </el-footer>
        </el-container>
    </div>

</template>

<script>
    export default {
        name: "index",
        data(){
            return{
                gn:true,
                yh:false,
                sj:false,
                kf:false,

            }
        },
        methods:{
            login(){
              this.$router.push({
                  path: '/account'
              })
            },
            goAbout(){
                this.$nextTick(function () {
                    let id=document.getElementById("footer")
                    id.scrollIntoView()
                })
            },
            goWechat(){
                this.$notify({
                    title:'wechat:',
                    message:'17753193111',
                    position:'bottom-right'
                });
            },
            goPhone(){
                this.$notify({
                    title: '热线电话',
                    message: '053188880121',
                    position: 'bottom-right'
                });
            },
            goQQQ(){
                location.href="tencent://message/?uin=1456183425&Site=qq&Menu=yes"
            },
            goTop(){
                this.$nextTick(function () {
                    let id=document.getElementById("top")
                    id.scrollIntoView()
                })
            },
            navigate(){
                this.$nextTick(function () {
                    let id=document.getElementById("hxys")
                    id.scrollIntoView()
                })

            },
            reset(){
                this.gn=false;
                this.yh=false;
                this.sj=false;
                this.kf=false;
            },
            ongn(){
                this.reset()
                this.gn=true;
            },
            onyh(){
                this.reset()
                this.yh=true;
            },
            onsj(){
                this.reset()
                this.sj=true;
            },
            onkf(){
                this.reset()
                this.kf=true;
            }
        }
    }
</script>

<style lang="less" scoped>

    .men-dc:hover .ul-dc{
        display: block!important;
        background-color: white;
        list-style: none;
        line-height: 40px;
        margin-left: 5%;
    }
    .talk-c{
        z-index: 999;
        width: 75px;
        height: 280px;
        background: aliceblue;
        right: 0;
        bottom: 10%;
        position: fixed;
    }
    .btnq:hover{
        border: 1px solid white;
        color: white;
    }
    .c-li{
        line-height: 45px;
    }
    .smallp{
        font-weight: normal;
    }
    .dicc {
        border: 1px solid red;
        width: 1000px; //设置足够的宽度
        margin: 0 auto;
        overflow: hidden;
        white-space:nowrap; //处理块元素中的空白符和换行                                    符的，这个属性保证图片不换行
    }

    /deep/ .el-main {
        text-align: left;
        /*padding: 20px !important;*/
        overflow: hidden !important;
    }

    /*.el-carousel__container{
        height: 570px;
    }*/


    .logo_Span {
        font-size: 50px;
    }

    .span_card {
        height: 200px;
        text-align: center;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        box-shadow: 0 0 20px 1px rgba(0, 0, 0, 0.1);
        border-radius: 10px;

        box-sizing: border-box;
        color: #666666;

        .left {
            display: flex;
            flex-direction: column;
            flex: 1;
            justify-content: space-around;
            height: 100%;
        }

        .addBold {
            font-weight: bold;
            font-size: 17px;

        }

        .right {

            display: flex;
            align-items: center;
            flex-direction: column;

            justify-content: center;
            flex: 0.5;
            height: 100%;
            color: #ffffff;
            background: #00e2cb;

        }
    }

    .el-menu--horizontal > .el-menu-item {
        color: #ffffff;
    }

    /*.el-menu--horizontal > .el-submenu .el-submenu__title {
        color: #ffffff;
    }*/

    /** {
        margin: 0px;
        padding: 0px;
    }*/

    /*.el-main, .el-header {
        padding: 0px;
    }*/


    .float_right {
        float: right !important;
        color: white;
    }

    .right_herd {
        width: 60%;
    }

    .el-carousel__item h3 {
        color: #475669;
        font-size: 18px;
        opacity: 0.75;
        line-height: 300px;
        margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n+1) {
        background-color: #d3dce6;
    }

    /*===================================*/
    .drag {
        position: relative;
        background-color: #e8e8e8;
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
    }

    .handler {
        width: 40px;
        height: 40px;

        border: 1px solid #ccc;
        cursor: move;
    }

    .handler_bg {
        background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==") no-repeat center;
    }

    .handler_ok_bg {
        background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==") no-repeat center;
    }

    .drag_bg {
        background-color: #7ac23c;
        height: 40px;
        width: 0px;
    }

    .drag_text {

        position: absolute;
        top: 0px;
        width: 100%;
        text-align: center;
        -moz-user-select: none;
        -webkit-user-select: none;
        user-select: none;
        -o-user-select: none;
        -ms-user-select: none;
    }


    .position-relative {
        position: absolute;
        top: 185px;
        right: 8%;
        z-index: 99;

        .login {
            box-shadow: 0 0 3px 0 rgba(255, 255, 255, 0.2);
            border-radius: 10px;
            min-width: 350px;
            padding: 30px;
            padding-top: 40px;
            background: rgba(10, 57, 113, 0.1);
        }
    }

    .el-input {
        height: 45px;
        background: transparent;

        input {
            padding-left: 10px;
            background: transparent;
        }

    }

    /deep/ .el-input__inner {
        height: 100%;
        background: transparent;
        border: 1px solid #3C618E;
        color: #ffffff;
    }

    /deep/ .el-form-item__content {
        line-height: 45px;
    }

    /deep/ .el-input__suffix {
        right: 20px;
    }


    /deep/ .el-menu--horizontal{
        border: none;
        padding: 0 20px;
        background:rgba(12,47,86,2.5);
    }

</style>
